const getAbbreviation = (str: any) => str.match(/\b([A-Za-z])/g).join('').toUpperCase();

export const makeAbbreviationIfLong = (str: string) => {
  if (str.split(' ').length > 2) {
    return getAbbreviation(str);
  }
  return str;
};